import React from "react";
import PropTypes from "prop-types";
import moment from "moment";
import "@assets/css/common/style_modal.css";

/**
 * 프리셋 상세정보 모달 컴포넌트
 * @param {Object} props - 컴포넌트 속성
 * @param {boolean} props.isOpen - 모달 표시 여부
 * @param {Object} props.preset - 프리셋 정보
 * @param {Function} props.onClose - 모달 닫기 함수
 */
const PresetDetailModal = ({ isOpen, preset, onClose }) => {
    if (!isOpen || !preset) return null;

    const userName = preset?.createdByName || '';

    return (
        <div className="modal-overlay active" id="preset-detail-modal">
            <div className="modal-container">
                <div className="modal-header">
                    <h3 className="modal-title">프리셋 상세정보</h3>
                    <button className="modal-close" onClick={onClose}>
                        &times;
                    </button>
                </div>
                <div className="modal-body">
                    <div className="detail-item-container">
                        <span className="detail-label">테마명</span>
                        <span className="detail-content">
                            {preset.themeName}
                        </span>
                    </div>
                    <div className="detail-item-container">
                        <span className="detail-label">프리셋명</span>
                        <span className="detail-content">
                            {preset.presetName}
                        </span>
                    </div>
                    <div className="detail-item-container">
                        <span className="detail-label">사용 기간</span>
                        <span className="detail-content">
                            {moment(preset.startDatetime).format('YYYYMMDD')} - {moment(preset.endDatetime).format('YYYYMMDD')}
                        </span>
                    </div>
                    <div className="detail-item-container">
                        <span className="detail-label">사용 시스템</span>
                        <span className="detail-content">
                            {preset.branchName || '없음'}
                        </span>
                    </div>
                    <div className="detail-item-container">
                        <span className="detail-label">배포 여부</span>
                        <span className="detail-content">
                            {preset.isActive ? "Y" : "N"}
                        </span>
                    </div>
                    <div className="detail-item-container">
                        <span className="detail-label">작성자</span>
                        <span className="detail-content">{userName}</span>
                    </div>
                </div>
                <div className="modal-footer">
                    <button
                        className="modal-btn modal-btn-primary"
                        onClick={onClose}
                    >
                        확인
                    </button>
                </div>
            </div>
        </div>
    );
};

PresetDetailModal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    preset: PropTypes.object,
    onClose: PropTypes.func.isRequired,
};

export default PresetDetailModal;
